'use client';

import React from 'react';

import {AsyncStaticPriceText} from '@udemy-v2/react-course-pricing';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {useClpPurchaseContext} from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import {TransactionalCTAButton} from '@/features/course-landing-page/components/transactional-cta-button/transactional-cta-button.react-component';
import styles from './enrollment-sticky-footer-content.module.scss';

/**
 * EnrollmentStickyFooterContent component displays price and CTA button for enrollment.
 * Conditionally hides price for courses included in subscription and shows 'Free' for free courses.
 * Renders when the course is free or included in subscription and the user is not already enrolled.
 */
export const EnrollmentStickyFooterContent: React.FC = () => {
    const {id: courseId} = useClpCourse();
    // Hide price if course is included in subscription, show 'Free' if course is free
    const {isCourseIncludedInUserSubscription} = useClpPurchaseContext();

    return (
        <div className={styles.container}>
            {!isCourseIncludedInUserSubscription && (
                <AsyncStaticPriceText
                    listPriceClassName="ud-heading-lg"
                    courseId={Number(courseId)}
                />
            )}
            <TransactionalCTAButton className={styles['enroll-now-cta-button']} udStyle="primary" />
        </div>
    );
};
